export const getNextAccountExpenseNumber = (accountExpenses) => {
    let nextNum = 0;
    accountExpenses.forEach(expense => {
        const num = parseInt(expense.number);
        if (nextNum < num) {
            nextNum = num;
        }
    });
    return ++nextNum;
}